// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

import i18n from './table-cell-presentation.properties';

const TABLE_CELL_PRESENTATION_TO_PERSISTENCE_KEY = {
  SINGLE_COLOR: 'singleColor',
  CLASSIFICATION: 'classification',
  HIGHLIGHTING: 'highlighting'
} as const;

/** @see net/disy/cadenza/workbook/table/web/service/TableCellPresentation.java */
export type TableCellPresentation = keyof typeof TABLE_CELL_PRESENTATION_TO_PERSISTENCE_KEY;

export const TableCellPresentation = {
  values: Object.keys(TABLE_CELL_PRESENTATION_TO_PERSISTENCE_KEY) as readonly TableCellPresentation[],
  toPersistenceKey: (value: TableCellPresentation) => TABLE_CELL_PRESENTATION_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = TableCellPresentation.values.find(key => TABLE_CELL_PRESENTATION_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No TableCellPresentation for key: ${persistenceKey}`); }
    return value;
  },
  i18n: (value: TableCellPresentation) => i18n(`<${value}>`),
} as const;

// </GENERATED-CODE>
